// @flow
import config from '../../config';
import { makeAPICall, APIError } from '../generalCreators';

export function getCurrentIndustryOrganisations(
  industryId: number,
  isAllocatedTo: ?boolean = true
): any {
  return function(dispatch, getState) {
    const endpoint = '/organisations';
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        industryId,
        isAllocatedTo
      }
    };

    return makeAPICall(endpoint, options).then(
      data => {
        const organisations = data.data.organisations;
        if (isAllocatedTo) {
          dispatch({
            type: 'UPDATE_CURRENT_INDUSTRY_ALLOCATED_ORGANISATIONS',
            allocated: organisations
          });
        } else {
          dispatch({
            type: 'UPDATE_CURRENT_INDUSTRY_UNALLOCATED_ORGANISATIONS',
            unallocated: organisations
          });
        }
      },
      error =>
        dispatch(APIError(error, 'Error getting currentIndustry Organisations'))
    );
  };
}

export function addOrganisationToIndustry(
  industryId: number,
  organisationId: number,
  dateUpdated: string
): any {
  return function(dispatch, getState) {
    const endpoint = '/organisation';
    const options = {
      method: 'PUT',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId
      },
      data: {
        industryId,
        dateUpdated
      }
    };

    return makeAPICall(endpoint, options).then(
      data => {
        dispatch(getCurrentIndustryOrganisations(industryId, true));
        dispatch(getCurrentIndustryOrganisations(industryId, false));
      },
      error =>
        dispatch(
          APIError(error, 'Error adding Organisation to currentIndustry')
        )
    );
  };
}

export function removeOrganisationFromIndustry(
  industryId: number,
  organisationId: number,
  dateUpdated: string
): any {
  return function(dispatch, getState) {
    const endpoint = '/organisation';
    const options = {
      method: 'PUT',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId
      },
      data: {
        industryId: 0,
        dateUpdated
      }
    };

    return makeAPICall(endpoint, options).then(
      data => {
        dispatch(getCurrentIndustryOrganisations(industryId, true));
        dispatch(getCurrentIndustryOrganisations(industryId, false));
      },
      error =>
        dispatch(
          APIError(error, 'Error removing Organisation from currentIndustry')
        )
    );
  };
}



// WEBPACK FOOTER //
// ./src/actions/industries/organisationCreators.js